import { CxEvent } from '@spartacus/core';

export class FbqGgCategoryPageEvent extends CxEvent {
  event?: string;
}
